import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

export interface SystemDictionaryBlock {
	title: string;
	dictionaries: SystemDictionary[]
}


@JsonObject('model.SystemDictionary')
export class SystemDictionary extends AbstractModel {
	@JsonProperty(Number, 'id')
	id: number;

	@JsonProperty(String, 'clazz')
	clazz?: string;

	@JsonProperty(Boolean, 'active')
	active?: boolean;

	@JsonProperty(String, 'color')
	color?: string;

	@JsonProperty(String, 'name')
	name?: string;

	@JsonProperty(String, 'title')
	title?: string;

  @JsonProperty(String, 'shortTitle')
  shortTitle?: string;
}
